;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import type React from 'react';

interface CoinStackIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function CoinStackIcon({ size = 24, ...props }: CoinStackIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Coin stack 5">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.1 2.93913C11 2.31304 9.6 2 8 2C6.4 2 5 2.31304 3.9 2.93913C2.8 3.46087 2 4.29565 2 5.44348V10.7652C2 11.8087 2.9 12.6435 4.2 13.2696C4.8 13.5826 5.5 13.7913 6.2 13.8957C6.8 14 7.4 14 8 14C11.3 14 14 12.5391 14 10.6609V5.44348C14 4.29565 13.2 3.46087 12.1 2.93913ZM4.3 3.87826C5.3 3.35652 6.5 3.04348 8 3.04348C9.5 3.04348 10.8 3.35652 11.7 3.87826C12.7 4.4 13 4.92174 13 5.44348C13 5.96522 12.6 6.48696 11.7 7.0087C11.2 7.21739 10.7 7.32174 10.2 7.53044C9.5 7.63478 8.8 7.73913 8 7.73913C7.2 7.73913 6.5 7.63478 5.8 7.53044C5.3 7.32174 4.8 7.21739 4.3 7.0087C3.4 6.48696 3 5.86087 3 5.44348C3 4.92174 3.4 4.29565 4.3 3.87826ZM3 7.32174C3.3 7.53043 3.6 7.73913 3.9 7.94783C4 7.94783 4.1 8.05217 4.2 8.05217C5.2 8.57391 6.6 8.78261 8 8.78261C9.4 8.78261 10.8 8.46957 11.8 8.05217C11.9 8.05217 12 7.94783 12.1 7.94783C12.4 7.73913 12.7 7.63478 13 7.32174V8.05217C13 8.26087 12.9 8.46957 12.8 8.67826C12.6 8.88696 12.2 9.30435 11.7 9.61739C10.8 10.0348 9.5 10.3478 8 10.3478C6.5 10.3478 5.3 10.0348 4.3 9.61739C3.8 9.30435 3.4 8.88696 3.2 8.57391C3.1 8.36522 3 8.15652 3 8.05217V7.32174ZM13 10.6609C13 11.1826 12.6 11.7043 11.7 12.2261C10.8 12.6435 9.5 13.0609 8 13.0609C6.5 13.0609 5.2 12.7478 4.3 12.2261C3.4 11.7043 3 11.0783 3 10.6609V9.93043C3.3 10.1391 3.6 10.3478 3.9 10.4522C5 11.0783 6.4 11.3913 8 11.3913C9.6 11.3913 11 11.0783 12.1 10.4522C12.4 10.3478 12.7 10.1391 13 9.93043V10.6609Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
